// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import Cooke from '../../../Texas/data/counties/Cooke.geo.json'
import Grayson from '../../../Texas/data/counties/Grayson.geo.json'
import Fannin from '../../../Texas/data/counties/Fannin.geo.json'
import Wise from '../../../Texas/data/counties/Wise.geo.json'
import Denton from '../../../Texas/data/counties/Denton.geo.json'
import Collin from '../../../Texas/data/counties/Collin.geo.json'
import Hunt from '../../../Texas/data/counties/Hunt.geo.json'
import Palo_Pinto from '../../../Texas/data/counties/Palo_Pinto.geo.json'
import Parker from '../../../Texas/data/counties/Parker.geo.json'
import Tarrant from '../../../Texas/data/counties/Tarrant.geo.json'
import Dallas from '../../../Texas/data/counties/Dallas.geo.json'
import Rockwall from '../../../Texas/data/counties/Rockwall.geo.json'
import Kaufman from '../../../Texas/data/counties/Kaufman.geo.json'
import Erath from '../../../Texas/data/counties/Erath.geo.json'
import Hood from '../../../Texas/data/counties/Hood.geo.json'
import Somervell from '../../../Texas/data/counties/Somervell.geo.json'
import Johnson from '../../../Texas/data/counties/Johnson.geo.json'
import Ellis from '../../../Texas/data/counties/Ellis.geo.json'
import Navarro from '../../../Texas/data/counties/Navarro.geo.json'

const counties = {
  Cooke,
  Grayson,
  Fannin,
  Wise,
  Denton,
  Collin,
  Hunt,
  Palo_Pinto,
  Parker,
  Tarrant,
  Dallas,
  Rockwall,
  Kaufman,
  Erath,
  Hood,
  Somervell,
  Johnson,
  Ellis,
  Navarro
}

export default counties
